import { createContext, useEffect, useState } from "react";

export let CartContext = createContext();

export default function CartProvider({ children }) {
  // Favorites
  let [favorites, setfavorits] = useState(() => {
    let savedFav = localStorage.getItem("favoritsitem");
    return savedFav ? JSON.parse(savedFav) : [];
  });

  let addtofavorites = (item) => {
    setfavorits((prev) => {
      if (prev.some((i) => i.id === item.id)) return prev;
      return [...prev, item];
    });
  };

  useEffect(() => {
    localStorage.setItem("favoritsitem", JSON.stringify(favorites));
  }, [favorites]);

  let removefromfavorite = (id) => {
    setfavorits((prev) => prev.filter((i) => i.id !== id));
  };

  // Cart
  let [cartitem, setcartitem] = useState(() => {
    let savedCart = localStorage.getItem("cartitem");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  // increasequantity

  let increasequantity = (id) => {
    setcartitem((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, quantity: item.quantity + 1 } : item
      )
    );
  };

  // Decreasequantity
  let Decreasequantity = (id) => {
    setcartitem((prevItems) =>
      prevItems.map((item) =>
        item.id === id && item.quantity > 1
          ? { ...item, quantity: item.quantity - 1 }
          : item
      )
    );
  };

  // removefromcart
  let removefromcart = (id) => {
    setcartitem((prevItems) => prevItems.filter((item) => item.id !== id));
  };

  let addtoCart = (item) => {
    setcartitem((prevItems) => [...prevItems, { ...item, quantity: 1 }]);
  };

  useEffect(() => {
    localStorage.setItem("cartitem", JSON.stringify(cartitem));
  }, [cartitem]);

  return (
    <CartContext.Provider
      value={{
        cartitem,
        addtoCart,
        increasequantity,
        Decreasequantity,
        removefromcart,
        addtofavorites,
        favorites,
        removefromfavorite,
      }}
    >
      {children}
    </CartContext.Provider>
  );
}
